














































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
@Component({
  name: "user-permissions-component",
})
export default class UserPermissionsComponent extends mixins(
  NotificationEvent
) {
  @Prop() superAdmin;
  @Prop() active;
  @Prop() selectUser;
  @Prop({ default: [] }) auxUsers;
  @Prop({ default: false }) isCampus;
  @Prop({ default: false }) isCampusAdmin;
  @Prop({ default: null }) superSpaceUser;

  confirmDelete = false;
  userDeleteId = 0;

  get spaceUser() {
    return this.selectUser;
  }
  get myUser() {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  get openModal(): boolean {
    return this.active;
  }
  set openModal(e) {
    this.$emit("close-modal", e);
  }

  get space() {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  get superSpace(): any {
    return this.$store.getters["SuperSpaceStore/getSuperSpace"];
  }
  disableOrEnableUser(id: number): void {
    if (!this.isCampus) {
      this.$store.dispatch("SpaceUserStore/enableUserAction", {
        spaceId: this.spaceUser.id,
        data: { enabled: !this.spaceUser.enabled },
        callback: async (user) => {
          if (!this.selectUser.superSpaceUser) {
            const superSpaceIndex = this.auxUsers.findIndex(
              (a) => a.id === user.superSpaceUser.id
            );
            if (superSpaceIndex >= 0) {
              const spaceIndex = this.auxUsers[
                superSpaceIndex
              ].spaceUsers.findIndex((a) => a.id === user.id);
              this.selectUser.enabled = user.enabled;
              delete user.superSpaceUser;
              this.auxUsers[superSpaceIndex].spaceUsers.splice(
                spaceIndex,
                1,
                user
              );
            }
          } else {
            const index = this.auxUsers.findIndex((a) => a.id === user.id);
            if (index >= 0) {
              this.selectUser.enabled = user.enabled;
              this.auxUsers.splice(index, 1, user);
            }
          }
        },
      });
    } else {
      this.$store.dispatch("SuperSpaceUserStore/enableSuperSpaceUserAction", {
        superSpaceUserId: id,
        data: { enabled: !this.spaceUser.enabled },
        callback: async (user) => {
          const index = this.auxUsers.findIndex((a) => a.id === user.id);
          if (index >= 0) {
            this.auxUsers.splice(index, 1, user);
            this.$emit("close-modal", false);
          }
        },
      });
    }
  }
  changePermission(id: number, permission: string): void {
    if (!this.isCampus) {
      this.$store.dispatch("SpaceUserStore/changePermissionsAction", {
        spaceId: id,
        data: {
          [permission]: !this.spaceUser[permission],
        },
        callback: async (user) => {
          if (!this.selectUser.superSpaceUser) {
            const superSpaceIndex = this.auxUsers.findIndex(
              (a) => a.id === user.superSpaceUser.id
            );
            if (superSpaceIndex >= 0) {
              const parse = Object.assign(
                [],
                this.auxUsers[superSpaceIndex].spaceUsers
              );
              const splice = parse.splice(1);
              try {
                const spaceIndex = splice.findIndex((a) => a.id === user.id);
                this.selectUser[permission] = user[permission];
                delete user.superSpaceUser;
                splice.splice(spaceIndex, 1, user);
              } catch (error) {
                console.log("changePermission ", error);
              }
            }
          } else {
            const index = this.auxUsers.findIndex((a) => a.id === user.id);
            if (index >= 0) {
              this.selectUser[permission] = user[permission];
              this.auxUsers.splice(index, 1, user);
            }
          }
        },
      });
    } else {
      this.$store.dispatch(
        "SuperSpaceUserStore/changeSuperSpaceUserPermissionsAction",
        {
          superSpaceUserId: id,
          data: {
            [permission]: !this.spaceUser[permission],
          },
          callback: async (user) => {
            const index = this.auxUsers.findIndex((a) => a.id === user.id);
            if (index >= 0) {
              this.selectUser[permission] = user[permission];
              this.auxUsers.splice(index, 1, user);
            }
          },
        }
      );
    }
  }
  confirmDeleteUser(spaceUserId: number): void {
    this.userDeleteId = spaceUserId;
    this.confirmDelete = true;
  }
  deleteSpaceUser(): void {
    this.confirmDelete = false;
    if (!this.isCampus) {
      this.$store.dispatch("SpaceUserStore/deleteSpaceUserAction", {
        spaceUserId: this.userDeleteId,
        callback: async () => {
          if (!this.selectUser.superSpaceUser) {
            const superSpaceIndex = this.auxUsers.findIndex(
              (a) =>
                a.spaceUsers.findIndex((a) => a.id === this.userDeleteId) >= 0
            );
            if (superSpaceIndex > 0) {
              if (this.auxUsers[superSpaceIndex].spaceUsers.length === 1) {
                this.auxUsers.splice(superSpaceIndex, 1);
              } else {
                const spaceIndex = this.auxUsers[
                  superSpaceIndex
                ].spaceUsers.findIndex((a) => a.id === this.userDeleteId);
                this.auxUsers[superSpaceIndex].spaceUsers.splice(spaceIndex, 1);
              }
            }
          } else {
            const index = this.auxUsers.findIndex(
              (a) => a.id === this.userDeleteId
            );
            if (index >= 0) {
              this.auxUsers.splice(index, 1);
            }
          }

          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.deleteSpaceUser")
          );

          this.$emit("close-modal", false);
        },
      });
    } else {
      this.$store.dispatch("SuperSpaceUserStore/deleteSuperSpaceUserAction", {
        superSpaceUserId: this.userDeleteId,
        callback: async () => {
          const index = this.auxUsers.findIndex(
            (a) => a.id === this.userDeleteId
          );
          if (index >= 0) {
            this.auxUsers.splice(index, 1);
          }
          this.onSuccess(
            i18n.t("notifications.titles.success"),
            i18n.t("notifications.descriptions.deleteSpaceUser")
          );

          this.$emit("close-modal", false);
        },
      });
    }
  }
}
